// frontend/src/pages/reports/reportsCatalogue.js
//
// Which reports the hub lists, in the order it lists them, and the colour each
// row is tinted with.
//
// Deliberately carries NO glyph. The glyph for a route belongs to
// config/appPages.js and is drawn through <PageIcon>. Colour and order are
// hub-specific, so they stay here.
//
// Kept out of ReportsHub.jsx so that file only exports the React component
// (react-refresh/only-export-components), the same split as
// riskLevels.js / RiskChip.jsx.

/** Reports shown on the hub, in display order. */
export const REPORTS = [
  {
    key: 'salesForecastAccuracy',
    path: '/reports/sales-forecast-accuracy',
    color: 'var(--color-primary)',
    bg: 'var(--color-primary-light)',
  },
  {
    key: 'stockout',
    path: '/reports/stockout',
    color: 'var(--color-error)',
    bg: 'var(--color-error-bg)',
  },
  {
    key: 'excessStock',
    path: '/reports/excess-stock',
    color: 'var(--color-warning)',
    bg: 'var(--color-warning-bg)',
  },
  {
    key: 'classification',
    path: '/reports/classification',
    color: 'var(--color-neutral)',
    bg: 'var(--color-neutral-bg)',
  },
  {
    key: 'gmroi',
    path: '/reports/gmroi',
    color: 'var(--color-success)',
    bg: 'var(--color-success-bg)',
  },
  {
    key: 'deadStock',
    path: '/reports/dead-stock',
    color: 'var(--color-error)',
    bg: 'var(--color-error-bg)',
  },
];
